<template lang="pug">
UiModal(
  :show="show"
  :allowClose="false"
  :allowOutclick="false"
  :title="title"
  :subtitle="subtitle"
  :leftActions="leftActions"
  :rightActions="rightActions"
)
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      show: false,
    };
  },

  mounted() {
    this.show = true;
  },

  computed: {
    title() {
      return this.params.title;
    },

    subtitle() {
      return this.params.description;
    },

    leftActions() {
      return [
        {
          variant: this.params.okVariant ?? "primary",
          label: this.params.okLabel ?? this.$t("actions.confirm"),
          icon: this.params.okIcon ?? null,
          onClick: this.confirm,
        },
      ];
    },

    rightActions() {
      return [
        {
          variant: this.params.cancelVariant ?? "smooth-secondary",
          label: this.params.cancelLabel ?? this.$t("actions.cancel"),
          icon: this.params.cancelIcon ?? null,
          onClick: this.reject,
        },
      ];
    },
  },

  methods: {
    confirm() {
      this.show = false;
      this.$emit("confirm");
    },

    reject() {
      this.show = false;
      this.$emit("reject");
    },
  },
};
</script>
